import { Module, ActionContext } from 'vuex'
import { SupplierRequestsState } from './module-types'
import { supplierRequests as supplierRequestsApi } from '@/api'

export const supplierRequests: Module<SupplierRequestsState, {}> = {
  namespaced: true,

  state: {
    activeCount: 0,
  },

  getters: {
    activeCount(state) {
      return state.activeCount
    },
  },

  mutations: {
    SET_ACTIVE_COUNT: (state, value: number) => {
      state.activeCount = value
    },
  },

  actions: {
    async fetchActiveCount({ commit }) {
      try {
        const response = await supplierRequestsApi.count()
        const count = response?.data?.count

        commit('SET_ACTIVE_COUNT', Number.isInteger(count) && count > 0 ? count : 0)
      } catch (error) {
        // The badge is optional, so a failed request simply hides it.
        commit('SET_ACTIVE_COUNT', 0)
      }
    },

    async listing(_, page: number) {
      return await supplierRequestsApi.list(page)
    },

    async find(_, supplierRequestId: number) {
      const response = await supplierRequestsApi.find(supplierRequestId)

      return response.data
    },

    async update(_, supplierRequestId: number) {
      return await supplierRequestsApi.update(supplierRequestId)
    },
  },
}
